<template>
  <tr class="table-analytics__data">
    <td data-cell="фото">
      <AvatarContainer :src="data.avatarLink ? apiUrl + 'static/' + data.avatarLink : require('@/assets/student_photo_placeholder.svg')" class="flex justify-center" :small="true"  />
    </td>
    <td data-cell="Тренер" style="font-size: 12px; padding: 0 10px;">{{data.coachsName}}</td>
    <td data-cell="Груп"><span class="text-[12px]">
      {{data.numberOfGroups}}
    </span>
    </td>
    <td data-cell="Гравців" style="font-size: 12px;">{{data.numberOfPlayers}}</td>
    <td data-cell="проведені тренування">
      <div ref="chartContainer" style="width: 90%; height: 90px;" class="mx-auto"></div>
    </td>
    <td data-cell="Останні матчі">
      <div class="flex gap-[8px] justify-center">
        <div 
          v-if="data.lastMatches.length"
          v-for="match in data.lastMatches" 
          class="w-[25px] h-[25px] text-white text-[10px] flex items-center justify-center font-bold"
          :class="{
            'bg-[#339989]': match.result == 'W',
            'bg-[#DA4167]': match.result == 'L',
            'bg-[#C59014]': match.result == 'D'
          }"  
        >{{ match.score }}</div>
        <div v-else class="text-white text-[10px]">Немає матчів</div>
      </div>
    </td>
  </tr>
</template>

<script>
import {onMounted, onUnmounted, ref, toRefs, watchEffect} from 'vue';
import * as echarts from "echarts";

export default {
  name: "AnalyticsComponentElement",
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  setup(props) {
    const { data } = toRefs(props);
    const chartContainer = ref(null);
    const barCharContainer = ref(null);
    let myBarChart;
    let myChart;

    const apiUrl = process.env.VUE_APP_API_URL;

    watchEffect(()=>{
      if (!barCharContainer.value) return;
      if (!myBarChart) {
        myBarChart = echarts.init(barCharContainer.value, "transparent", {renderer: "svg"});
      }
      const optionBar = {
        color: ["#C59014"],
        xAxis: {
          type: 'category',
          show: false,
        },
        yAxis: {
          type: 'value',
          show: false,
        },
        legend: {
          show: false
        },
        series: [
          {
            name: "Сальдо",
            data: data.value.totalPerYear,
            type: 'bar',
            label: {
              show: true,
              fontSize:14,
              position: 'top',
              color: "#C59014"
            },
          }
        ]
      };
      myBarChart.setOption(optionBar, true);

    })
    watchEffect(() => {
      if (!chartContainer.value) return;
      if (!myChart) {
        myChart = echarts.init(chartContainer.value, "transparent", {renderer: "svg"});
      }
      const option = {
        color: ["#C59014"],
        xAxis: {
          type: 'category',
          show: false,
        },
        yAxis: {
          type: 'value',
          show: false,
        },
        legend: {
          show: false
        },
        series: [
          {
            name: "Сальдо",

            data: data.value.trainingsPerYear,
            type: 'line',
            symbol: "circle",
            barWidth: '60%',
            symbolSize: 0,
            label: {
              show: true,
              fontSize:10,
              position: 'top',
              color: "#C59014"
            },
            lineStyle: {
              width: 2
            }
          }
        ]
      };


      myChart.setOption(option, true);
    });

    onMounted(() => {
      if (!chartContainer.value||!barCharContainer.value) return;
    });
    const updateChartSize = () => {
      if(myChart)myChart.resize();
      if(myBarChart)myBarChart.resize();
    };
    onMounted(() => {
      window.addEventListener('resize', updateChartSize);
      console.log(data.value);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', updateChartSize);
        // myChart.dispose(); // Очищуємо графік при знищенні компонента
        // myBarChart.dispose(); // Очищуємо графік при знищенні компонента
    });

    return { chartContainer,barCharContainer, apiUrl};
  }
};
</script>

